<template>
  <div class="template-container" :class="[SIDE_MENU == 1 ? 'opensidebarScreen':'closesidebarScreen' ]" v-if="isAppLoaded">
    <base-modal />
    <funder-header/>
    <funder-sidebar type="basic"/>

    <transition v-if="parentMounted"
      name="fade"
      mode="out-in">
      <router-view />
    </transition>
    <site-footer/>
  </div>
  <div v-else class="template-container">
    <font-awesome-icon icon="spinner" class="fa-spin"/>
  </div>
</template>
<script type="text/babel">
  import FunderHeader from './partials/FunderHeader.vue'
  import SiteFooter from './partials/TheSiteFooter.vue'
  import FunderSidebar from './partials/FunderSidebar.vue'
  import Layout from '../../helpers/layout'
  import BaseModal from '../../components/base/modal/BaseModal'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      FunderHeader, FunderSidebar, SiteFooter, BaseModal
    },
    data () {
      return {
        'header': 'header',
        parentMounted : false
    }
    
    },
    computed: {
      ...mapGetters([
        'isAppLoaded'
      ]),
      ...mapGetters('general', [
        'SIDE_MENU'
      ]),
      ...mapGetters('company', {
        selectedCompany: 'getSelectedCompany',
        companies: 'getCompanies'
      }),

      isShow () {
        return true
      }
    },
    mounted () {
      Layout.set('layout-default')
    },

    created () {

      this.bootstrap().then((res) => {
        this.setInitialCompany()
      })
    },

    methods: {
      ...mapActions(['bootstrap']),
      ...mapActions('company', ['setSelectedCompany']),
      setInitialCompany () {
        let selectedCompany = Ls.get('selectedCompany') !== null

        if (selectedCompany) {
          let foundCompany = this.companies.find((company) => company.id === parseInt(selectedCompany))

          if (foundCompany != undefined) {
            this.setSelectedCompany(foundCompany)
            return
          }
        }

        this.setSelectedCompany(this.companies[0])
        this.parentMounted = true
      }
    }
  }
</script>
<style lang="scss" scoped>
  body {
    background-color: #f8f8f8;
  }
</style>
